import { AppBar, Box, Button, IconButton, Typography } from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { differenceInCalendarDays } from "date-fns";

const AppTrialPeriod = ({
  isTemporaria,
  empresa,
  setOpenTutorial,
  openTutorial,
}) => {
  const getDifferenceBlockDate = () => {
    if (empresa.dataBloqueio) {
      const date1 = new Date(empresa.dataBloqueio);
      const date2 = new Date();
      return differenceInCalendarDays(date1, date2);
    }
  };
  function handleClickLinkPlano() {
    if (empresa) {
      window.open(
        "https://app.galaxpay.com.br/landing1868454118/planoqrpedir",
        "_blank"
      );
    }
  }
  function handleEnviarWhatsApp() {
    const fone = "5546991390992";

    var mensagem = `Olá, sou da empresa ${empresa?.nome}, estou experimentando o Qrpedir e gostaria de tirar uma dúvida!`;
    window.open(`https://wa.me/${fone}?text=${mensagem}`, "_blank");
  }
  function getMensagemBoqueio() {
    if (getDifferenceBlockDate() >= 2) {
      return (
        <Typography
          variant="body1"
          align="center"
          style={{
            position: "relative",
            left: window.innerWidth > 600 ? "54px" : "0",
            fontFamily: "Bebas Neue",
            fontSize: "20px",
          }}
        >
          <strong>{getDifferenceBlockDate()}</strong> dias restantes
        </Typography>
      );
    } else if (getDifferenceBlockDate() === 1) {
      return (
        <Typography
          variant="body1"
          align="center"
          style={{
            position: "relative",
            left: window.innerWidth > 600 ? "54px" : "0",
            fontFamily: "Bebas Neue",
            fontSize: "20px",
          }}
        >
          Último dia de teste grátis!
        </Typography>
      );
    } else if (getDifferenceBlockDate() < 1) {
      return (
        <Box display="block">
          <Typography
            variant="body1"
            align="center"
            style={{ fontFamily: "Bebas Neue" }}
          >
            Seu período de avaliação terminou 😟
            <Button
              onClick={handleClickLinkPlano}
              variant="outlined"
              size="small"
            >
              Assinar agora
            </Button>
          </Typography>
        </Box>
      );
    }
  }
  if (!isTemporaria) return null;
  return (
    <AppBar position="fixed" color="secondary">
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        style={{ height: "40px" }}
      >
        <Typography
          style={{
            fontFamily: "Bebas Neue",
            fontSize: "20px",
            margin: "15px",
          }}
        >
          Periodo de teste
        </Typography>

        {getMensagemBoqueio()}

        <Box>
          <Button
            onClick={() => setOpenTutorial(!openTutorial)}
            color="primary"
            size="small"
          >
            Como funciona?
          </Button>
          <Button
            onClick={handleClickLinkPlano}
            className={"pendenteAnimationGreen"}
            variant="contained"
            size="small"
            style={{
              fontFamily: "Bebas Neue",
              fontSize: "18px",
              padding: "0 10px",
              backgroundColor: "#66BB6A",
              margin: "0 10px",
            }}
          >
            Assinar
          </Button>

          <IconButton
            style={{ marginRight: "15px" }}
            onClick={() => handleEnviarWhatsApp()}
            size="large"
          >
            <WhatsAppIcon color="primary" />
          </IconButton>
        </Box>
      </Box>
    </AppBar>
  );
};

export default AppTrialPeriod;
